import StaticBanner from '@components/banners/StaticBanner.vue';
import Html5Banner from '@components/banners/Html5Banner.vue';

export default {
  methods: {
    bannerComponent(resource) {
      return resource.isStatic() ? 'static-banner' : 'html5-banner';
    },
  },

  components: {
    StaticBanner,
    Html5Banner,
  },
};
